export var userRoles = [
    {
        id: 0,
        description: 'Agent',
        type: 'RoleTypeAgent',
        enabled: true,
    },
    {
        id: 1,
        description: 'Agency Admin',
        type: 'RoleTypeAgencyAdmin',
        enabled: true,
    },
];
